import { Path } from 'slate';

import HelptapEditor from '../../../helpers';
import elementTypes from '../../types';

import {
  makeDropZone,
  addDraggability
} from './native';
import { clearLayoutHighlight } from './layout-highlight';
import { tryDropInLayout, tryHighlightLayoutDrop } from './layout-session';

const HIGHLIGHT_CLASS_NAME = 'highlight-drop-line';
const TOP_HIGHLIGHT_CLASS_NAME = 'top';
const BOTTOM_HIGHLIGHT_CLASS_NAME = 'bottom';
const NOT_ACCEPTABLE_TARGET_CLASS_NAME = 'not-acceptable-target';

let sharedData = '';
let finalDestination = null;

export function tryInitializeDraggability(editor, options) {

  const element = options.element;
  const elementPathReference = options.elementPathReference;
  const getPath = options.getPath;

  return addDraggability(element, {
    onDragStart(event) {

      if (HelptapEditor.dragAndDrop.canSelectHandleNode(editor, getPath()) === true) {
        sharedData = JSON.stringify({
          elementPath: getPath(),
          selection: {
            anchor: {
              path: getPath(),
              offset: 0
            },
            focus: {
              path: getPath(),
              offset: 0
            }
          }
        });
      } else {
        sharedData = JSON.stringify({ elementPath: getPath(), selection: editor.selection });
      }
    }
  });

};

export function tryUninitializeDraggability(editor, options) {

};

function willInsertBelowTarget(element, event) {
  const elementRectangle = element.getBoundingClientRect();
  const halfOfHeight = elementRectangle.height / 2;
  const top = (elementRectangle.y + halfOfHeight);

  if (event.pageY > top) {
    return true;
  } else {
    return false;
  }
}

function canReceiverAccept(editor, start, destination, caller) {
  return HelptapEditor.dragAndDrop.canReceiverAccept(editor, start.selection, destination, caller);
}

function highlightDropZone(editor, element, event, start, destination) {

  finalDestination = [...destination];

  if (tryHighlightLayoutDrop(editor, element, event, start, destination) === true) {
    return;
  }

  const classList = element.classList;

  if (classList.contains(HIGHLIGHT_CLASS_NAME) === false) {
    classList.add(HIGHLIGHT_CLASS_NAME);
  }
  classList.remove(NOT_ACCEPTABLE_TARGET_CLASS_NAME);
  if (canReceiverAccept(editor, start, destination, 'highlightDropZone') === false) {
    classList.add(NOT_ACCEPTABLE_TARGET_CLASS_NAME);
    return;
  }

  if (willInsertBelowTarget(element, event) === true) {
    classList.remove(TOP_HIGHLIGHT_CLASS_NAME);
    if (classList.contains(BOTTOM_HIGHLIGHT_CLASS_NAME) === false) {
      classList.add(BOTTOM_HIGHLIGHT_CLASS_NAME);
    }
    finalDestination = Path.next([...destination]);
  } else {
    classList.remove(BOTTOM_HIGHLIGHT_CLASS_NAME);
    if (classList.contains(TOP_HIGHLIGHT_CLASS_NAME) === false) {
      classList.add(TOP_HIGHLIGHT_CLASS_NAME);
    }
  }

  const fromPathReferences = HelptapEditor.dragAndDrop.getSameLevelPathReferences(editor, JSON.parse(sharedData).selection);
  const newStart = fromPathReferences[0].current;

  if (Path.levels(newStart).length === Path.levels(destination).length) {

    if (Path.isAfter(destination, newStart) === true && Path.hasPrevious(finalDestination) === true) {
      finalDestination = Path.previous(finalDestination);
    }

  }

}

function unhighlightDropZone(element) {
  const classList = element.classList;
  classList.remove(HIGHLIGHT_CLASS_NAME);
  classList.remove(TOP_HIGHLIGHT_CLASS_NAME);
  classList.remove(BOTTOM_HIGHLIGHT_CLASS_NAME);
  classList.remove(NOT_ACCEPTABLE_TARGET_CLASS_NAME);
  clearLayoutHighlight();
}

export function tryMakeElementDroppable(editor, element, options) {

  const node = options.node;
  const elementPathReference = options.elementPathReference;
  const getPath = options.getPath;

  if (node.type === elementTypes.BASE) {
    return function noop() {};
  }

  return makeDropZone(element, editor, {
    onDragOver(event, editorLevelNode) {
      const movedSource = sharedData;
      if (movedSource === '') {
        return;
      }
      const start = JSON.parse(movedSource);

      highlightDropZone(editor, editorLevelNode, event, start, getPath());
      event.stopPropagation();
    },
    onDrop(event, editorLevelNode) {
      unhighlightDropZone(editorLevelNode);

      if (sharedData === '') {
        if (event.dataTransfer.files.length !== 0) {
          HelptapEditor.file.handleDrop(editor, event);
        }
        return;
      }

      const data = JSON.parse(sharedData);

      if (tryDropInLayout(editor, data) === false) {
        HelptapEditor.dragAndDrop.tryMoveNodeV2(editor, event, editorLevelNode, getPath(), finalDestination, data);
      }
      sharedData = '';
      event.stopPropagation();
    },
    onDragEnter(event, editorLevelNode) {},
    onDragLeave(event, editorLevelNode) {
      unhighlightDropZone(editorLevelNode);
    }
  });

}